// import 'antd/lib/popover/style/index.css';
import Popover from 'antd/lib/popover/index.js';

export default Popover;
